export const SHOW_MENU = 'SHOW_MENU';

export const showMenu = data => {
	return {
		type: SHOW_MENU,
		data
	};
};

export const SET_TEXT = 'SET_TEXT';

export const setText = text => {
	return {
		type: SET_TEXT,
		text
	};
};

export const SET_DESC_FORMAT = 'SET_DESC_FORMAT';

export const setDescriptionFormat = formatFunc => {
	return {
		type: SET_DESC_FORMAT,
		format: formatFunc
	};
};